import { render, staticRenderFns } from "./form_indicadores_administradores.vue?vue&type=template&id=4ccd87cc&"
import script from "./form_indicadores_administradores.vue?vue&type=script&lang=ts&"
export * from "./form_indicadores_administradores.vue?vue&type=script&lang=ts&"
import style0 from "./form_indicadores_administradores.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports